/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';

import { ReportSort } from '../reports/models';
import { CropField, CropFieldType, CustomerProgress } from '../shared/models';

export enum AppActionTypes {
  ResetCropFieldType = '[App] Reset crop field type',
  SetCropFieldType = '[App] Set crop field type',
  ResetCropYear = '[App] Reset crop year',
  SetCropYear = '[App] Set crop year',
  GetDefaultCropYear = '[App] Get default crop year',
  SetDefaultCropYear = '[App] Set default crop year',
  SetAvailableCropYears = '[App] Set available crop years',
  ImportCropYears = '[App] Set crop years',
  ContextChanged = '[App] Context changed',
  GetCustomerData = '[App] Get customer data',
  SelectAllCropFields = '[App] Select all cropfields',
  ToggleCropFields = '[App] Toggle cropfields',
  SetSearch = '[App] Set Search',
  OpenOverview = '[App] Open overview',
  ViewSalesPotential = '[App] View sales potential',
  OpenFmsDiagnose = '[App] Open FMS diagnose',
  SelectCropFields = '[App] Select cropfields',
  ShowCopyFieldsToManureSpaceDialog = '[App] Show copy cropfields to manure space dialog',
  GetReportSort = '[App] Get report sort',
  SetReportSort = '[App] Set report sort',
  ToggleReportSortOption = '[App] Toggle report sort option',
  ToggleReportSortDirection = '[App] Toggle report sort direction',
  LoadCustomerProgress = '[App] Load customer progress',
  LoadCustomerProgressSuccess = '[App] Load customer progress success',
  ToggleCustomerProgressAdvice = '[App] Toggle customer progress advice',
  ToggleCustomerProgressManure = '[App] Toggle customer progress manure',
  LoadAvailableTgaCrops = '[App] Load available TGA crops',
  LoadAvailableTgaCropsSuccess = '[App] Load available TGA crops success',
}

export class ResetCropFieldType implements Action {
  readonly type = AppActionTypes.ResetCropFieldType;
  constructor(public readonly cropFieldType?: CropFieldType) {}
}

export class SetCropFieldType implements Action {
  readonly type = AppActionTypes.SetCropFieldType;
}

export class ResetCropYear implements Action {
  readonly type = AppActionTypes.ResetCropYear;
  constructor(public readonly cropYear?: number) {}
}

export class SetCropYear implements Action {
  readonly type = AppActionTypes.SetCropYear;
}

export class GetDefaultCropYear implements Action {
  readonly type = AppActionTypes.GetDefaultCropYear;
}

export class SetDefaultCropYear implements Action {
  readonly type = AppActionTypes.SetDefaultCropYear;
  constructor(public readonly defaultYear: number) {}
}

export class SetAvailableCropYears implements Action {
  readonly type = AppActionTypes.SetAvailableCropYears;
  constructor(public readonly availableCropYears: number[]) {}
}

export class ImportCropYears implements Action {
  readonly type = AppActionTypes.ImportCropYears;
  constructor(public readonly cropYears: number[]) {}
}

export class ContextChanged implements Action {
  readonly type = AppActionTypes.ContextChanged;
}

export class GetCustomerData implements Action {
  readonly type = AppActionTypes.GetCustomerData;
}

export class SelectAllCropFields implements Action {
  readonly type = AppActionTypes.SelectAllCropFields;
}

export class SelectCropFields implements Action {
  readonly type = AppActionTypes.SelectCropFields;
  constructor(public readonly cropFields: CropField[]) {}
}

export class ToggleCropFields implements Action {
  readonly type = AppActionTypes.ToggleCropFields;
  constructor(public readonly cropFields: CropField[]) {}
}

export class SetSearch implements Action {
  readonly type = AppActionTypes.SetSearch;
  constructor(public readonly search: boolean) {}
}

export class OpenOverview implements Action {
  readonly type = AppActionTypes.OpenOverview;
}

export class ViewSalesPotential implements Action {
  readonly type = AppActionTypes.ViewSalesPotential;
}

export class OpenFmsDiagnose implements Action {
  readonly type = AppActionTypes.OpenFmsDiagnose;
}

export class ShowCopyFieldsToManureSpaceDialog implements Action {
  readonly type = AppActionTypes.ShowCopyFieldsToManureSpaceDialog;
}

export class GetReportSort implements Action {
  readonly type = AppActionTypes.GetReportSort;
}

export class SetReportSort implements Action {
  readonly type = AppActionTypes.SetReportSort;
  constructor(public readonly reportSort: ReportSort) {}
}

export class ToggleReportSortOption implements Action {
  readonly type = AppActionTypes.ToggleReportSortOption;
}

export class ToggleReportSortDirection implements Action {
  readonly type = AppActionTypes.ToggleReportSortDirection;
}

export class LoadCustomerProgress implements Action {
  readonly type = AppActionTypes.LoadCustomerProgress;
}

export class LoadCustomerProgressSuccess implements Action {
  readonly type = AppActionTypes.LoadCustomerProgressSuccess;
  constructor(public readonly customerProgress: CustomerProgress) {}
}

export class ToggleCustomerProgressAdvice implements Action {
  readonly type = AppActionTypes.ToggleCustomerProgressAdvice;
}

export class ToggleCustomerProgressManure implements Action {
  readonly type = AppActionTypes.ToggleCustomerProgressManure;
}

export class LoadAvailableTgaCrops implements Action {
  readonly type = AppActionTypes.LoadAvailableTgaCrops;
}

export class LoadAvailableTgaCropsSuccess implements Action {
  readonly type = AppActionTypes.LoadAvailableTgaCropsSuccess;
  constructor(public readonly availableTgaCrops: number[]) {}
}

export type AppActions =
  | ResetCropFieldType
  | SetCropFieldType
  | ResetCropYear
  | SetCropYear
  | GetDefaultCropYear
  | SetDefaultCropYear
  | SetAvailableCropYears
  | ImportCropYears
  | ContextChanged
  | SelectAllCropFields
  | ToggleCropFields
  | SetSearch
  | SelectCropFields
  | ShowCopyFieldsToManureSpaceDialog
  | ViewSalesPotential
  | OpenFmsDiagnose
  | GetReportSort
  | SetReportSort
  | ToggleReportSortOption
  | ToggleReportSortDirection
  | LoadCustomerProgress
  | LoadCustomerProgressSuccess
  | ToggleCustomerProgressAdvice
  | ToggleCustomerProgressManure
  | LoadAvailableTgaCrops
  | LoadAvailableTgaCropsSuccess;
